import { render } from "./StockReportsSummaryCard.vue?vue&type=template&id=2ebd640c&scoped=true"
import script from "./StockReportsSummaryCard.vue?vue&type=script&lang=js"
export * from "./StockReportsSummaryCard.vue?vue&type=script&lang=js"

import "./StockReportsSummaryCard.vue?vue&type=style&index=0&id=2ebd640c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebd640c"]])

export default __exports__